
import type { SVGProps } from 'react';
const SvgNewsletter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#newsletter_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M3.333 17.667V7.47l7.589 5.192c.252.227.57.34.89.34.319 0 .638-.113.89-.34l7.965-5.45-.002 10.456zM19.588 6.334l-7.681 5.255a1 1 0 0 0-.095.08 1 1 0 0 0-.095-.08L4.035 6.334zm1.079-1.333H3.333C2.598 5 2 5.599 2 6.334v11.333c0 .736.598 1.334 1.333 1.334h17.334c.735 0 1.333-.598 1.333-1.334V6.334c0-.735-.598-1.333-1.333-1.333"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="newsletter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNewsletter;
